import React from 'react';

const BS_ButtonGroups = () => {
    return (
        <div>
            <h1>BS_ButtonGroups Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_ButtonGroups;
